export const event_type = {
    solutionEstimateEdit: "solution_estimate_edit"
}

export const solutionEstimateKeys = {
    solution: "Solution",
    description: "R/R Description",
    totalCost: "Cost",
    categoryName: "Category Number"
}

export const ordersKeys = {
    address: "Address",
    agentrole: "Client Role",
    firstName: "Client Name",
    indrole: "Agent Role",
    clientphone: "Agent Mobile #",
    clientemail: "Agent Email",
    duedate: "Due Date",
    homeinsurl: "Home Inspections Report",
    ddraurl: "DDRA",
    wdourl: "WDO Report",
    structengurl: "Structural Report",
    wellurl: "Well Report",
    email: "Client Email",
    phone: "Client Mobile #",
    billing_myfield23: "Buyer / Seller Name",
    billing_myfield24: "Additional Email to send S.E",
    firmsName: "Firm Name",
    officesName: "Affiliate Name",
    marketName: "Local Market"
}

export const SolutionEstimateAuditOp = [
    'solution_estimate_edit',
    'solution_estimate_delete',
    'solution_estimate_create',
    'approve_to_client',
    'approve_to_client_altered',
    'sms_send_approve_to_client',
    'email_send_approve_to_client',
    'submit_se_status'
];

export const OrdersAuditOp = [
    'create_order',
    'update_order',
    'create_order_claim'
]

export const ordersTableField = [
    "marketId",
    "firmId",
    "officeId",
    "productId",
    "longitude",
    "latitude",
    "id"
]

export const userPermisssionAuditField = [
    'user_activate_deactivate',
    'make_exe_role_perm',
    "create_user",
    "edit_user",
    "delete_user"
];

export const userPermisssionAuditField1 = [
    'create_user_role_perm',
];

export const reportsField = [
    "homeinsurl",
    "ddraurl",
    "supportReportUrl",
    "uniqueReportUrl",
    "wdourl",
    "structengurl",
    "wellurl",
]

export const SolutionEstimation = [
    "delete_se_into_db",
    "create_se_into_db",
    "update_se_into_db"
];

export const solutionEstimateDBKeys = {
    solution: "Solution",
    keyPrimCategory: "Primary Category",
    subcategory: "Sub Category",
    key1: "Keywords 1",
    key2: "Keywords 2",
    key3: "Keywords 3",
    key4: "Keywords 4",
    costOption: "Cost Option",
    totalCost: "Cost",
}


export const configurationAudit = [
    "create_product",
    "edit_product",
    "delete_product",
    "create_coupon",
    "edit_coupon",
    "delete_coupon",
    "create_role",
    "edit_role",
    "delete_role",
    "create_status",
    "edit_status",
    "delete_status",
];

export const configurationKeys = {
    productName: "Product name",
    sku: "Sku",
    productDesc1: "Description",
    productPrice: "Price",
    couponCode: "Coupon code",
    couponDesc: "Coupon description",
    couponAmount: "Coupon amount",
    totalLimit: "Total limit",
    usageLimit: "Usage limit",
    expireDate: "Expire date",
    roleDescription: "Role description",
    roleName: "Role name",
    displayStatus: "Display status",
}

export const configurationUserKey = {
    firstName: 'First name',
    lastName: 'Last name',
    email: 'Email',
    phoneNumber: 'Phone number',
    address: 'Address',
    userRole: 'User role '

}

export const marketCompanyAffiliateKeys = {
    marketId: 'The market',
    firmId: 'The firm',
    officeId: 'The office'
}

export const marketCompanyAffiliate = [
    "create_market_firm_office"
];

export const archiveAuditType = [
    "archive",
    "unarchive"
];

export const archiveDBKeys = {
    id: "Order Id",
    archive: "Archive",

}

export const bannerAuditLog = [
    "create_banner_image",
    "edit_banner_image",
    "create_banner_desc",
    "edit_banner_desc",
    "delete_banner",
]

export const bannerReviewKeys = {
    description: "Description",
    imageUrl: "Image",
}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/utils/e-commerce/auditLog.ts